import { createAsyncThunk } from "@reduxjs/toolkit";
import * as authService from "../../services/authService";
import { enqueueSnackbar } from "notistack";

export const registerCreator = createAsyncThunk(
  "auth/registerCreator",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await authService.registerCreator(userData);
      enqueueSnackbar(response.message || "Registration successful", {
        variant: "success",
      });
      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const registerBrand = createAsyncThunk(
  "auth/registerBrand",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await authService.registerBrand(userData);
      enqueueSnackbar(response.message || "Registration successful", {
        variant: "success",
      });
      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const login = createAsyncThunk(
  "auth/login",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await authService.login(userData);

      if (response.data?.authentication) {
        localStorage.setItem("token", response.data.authentication.accessToken);
      }

      enqueueSnackbar(response.message || "Login successful", {
        variant: "success",
      });
      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (otpData, { rejectWithValue }) => {
    try {
      const response = await authService.verifyOtp(otpData);

      // Store token if provided after OTP verification
      if (response.data?.authentication) {
        localStorage.setItem("token", response.data.authentication.accessToken);
      }

      enqueueSnackbar(response.message || "OTP verified successfully", {
        variant: "success",
      });
      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const socialLogin = createAsyncThunk(
  "auth/socialLogin",
  async (socialData, { rejectWithValue }) => {
    try {
      const response = await authService.socialLogin(socialData);

      if (response.data?.authentication) {
        localStorage.setItem("token", response.data.authentication.accessToken);
      }

      enqueueSnackbar(response.message || "Social login successful", {
        variant: "success",
      });
      return response;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const token = state.auth.user?.token || localStorage.getItem("token");

      if (!token) {
        throw new Error("Authentication token not found");
      }

      const response = await authService.logout(token);
      localStorage.removeItem("token");
      enqueueSnackbar(response.message || "Logged out successfully", {
        variant: "success",
      });
      return response;
    } catch (error) {
      localStorage.removeItem("token");
      enqueueSnackbar(error.message, { variant: "error" });
      return rejectWithValue(error);
    }
  }
);
